export default __webpack_public_path__ + "static/media/gear-svg.b100db52.svg";